import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { setDefaultTreasuryAccount } from '../treasuryAccountsEndpoints'
import { treasuryAccountKeys } from '../treasuryAccountsQueryKeys'

export function useSetDefaultTreasuryAccountMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: setDefaultTreasuryAccount,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: treasuryAccountKeys.lists() })
    },
  })
}
